export default "__VITE_ASSET__urPus3r9__"